import React from 'react'
import Grid from "@material-ui/core/Grid";
import Container from '@material-ui/core/Container';
// import Typography from '@material-ui/core/Typography';

const Banner = (props) => {
    return (
        <section id='about-us-banner'>
            <Container maxWidth={false} disableGutters>
                <Grid container className='about-us-banner'>
                    <Grid item xs={12} className='overlay'>
                        <div className='col-md-8 col-md-offset-2 intro-text'>
                            {/* <Typography variant="h1">
                                GET IN TOUCH
                            </Typography>
                            <span></span>
                            <Typography variant="body1">
                                We’re always on the move. Give us a shout.
                            </Typography> */}
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </section>
    )
}

export default Banner;